import { useItemStore } from '@/features/common/stores/itemStore';
import { STORE_ID_TYPES } from '@/constants';

export const useOrdersStore = useItemStore(STORE_ID_TYPES.ORDERS);
